export default "__VITE_ASSET__B4aquP4h__"